import React from 'react';
import UsersByRole from './UsersByRole';

const Agents = () => (
  <UsersByRole
    role="AGENT"
    title="Agents"
    subtitle="View and search property agents on the platform."
    detailBasePath="/system-admin/agents"
  />
);

export default Agents;
